export default "__VITE_ASSET__cdcb2220__"